<div class="container">
    <pre>{{ file }}</pre>
</div>
<div class="control">
    <app-button-generator
        [buttonGenInput]="closeButtonGenInput"
    ></app-button-generator>
</div>
